module.exports = __webpack_public_path__ + "img/btn-back.8df6c523.svg";